import Home from "./pages/home/Home";

function App() {
  return (
    <div className="body">
      <Home />
    </div>
  );
}

export default App;
